import { IMxrConfig, MxrConfig } from '@/interfaces/MxrConfig';
import { PromotionCarouselItem } from '@/interfaces/PromotionCarouselItem';
import {
	GET_MXR_CONFIG,
	GET_MXR_JSON_DATA,
	NEXT_CARD,
	PREV_CARD,
	SELECT_CARD,
	SELECT_TAB,
	SET_ACTIVE_CARD,
	SET_CAROUSEL_PROMOTIONS,
	SET_MXR_CONFIG,
	SET_MXR_JSON_DATA,
	SET_RETAILER,
} from '@/store/types';
import { IPromotion } from '@/interfaces/Promotion';

import { MessageEventUtil } from './MessageEventUtil';

export const addMessageHandlers = (store: any): void => {
	const meu = new MessageEventUtil();
	meu.addMessageCallback('updateMXRConfig', {}, (payload) => {
		store.dispatch(SET_MXR_CONFIG, MxrConfig.create(payload.message));
		if (!payload.message.retailerIntegration) {
			store.dispatch(SET_RETAILER);
		}
	});
	meu.addMessageCallback('selectMXRTab', {}, (payload) => {
		store.commit(SELECT_TAB, payload.message.tab);
	});
	meu.addMessageCallback('selectMXRCard', {}, (payload) => {
		store.commit(SELECT_CARD, payload.message.card);
	});
	meu.addMessageCallback('prevMXRCard', {}, (payload) => {
		store.commit(PREV_CARD);
	});
	meu.addMessageCallback('nextMXRCard', {}, (payload) => {
		store.commit(NEXT_CARD);
	});
	meu.addMessageCallback('setCarouselPromotions', {}, (payload) => {
		const carousels: PromotionCarouselItem[] =
			payload.message.carousels!.map((carousel: any) => {
				carousel.promotions.forEach((promo: IPromotion) => {
					promo.uniqueId = promo.uniqueId || Math.random();
				});
				const pci = new PromotionCarouselItem(
					carousel.id,
					carousel.heading,
					carousel.promotions,
					[]
				);
				return pci;
			});
		store.dispatch(SET_CAROUSEL_PROMOTIONS, carousels);
	});
	meu.addMessageCallback('updateRetailer', {}, (payload) => {
		const t = JSON.parse(store.getters[GET_MXR_JSON_DATA]);
		t.retailer = payload.message.retailer;
		store.dispatch(SET_MXR_CONFIG, MxrConfig.create(t));
		store.commit(SET_MXR_JSON_DATA, JSON.stringify(t));
	});
	meu.addMessageCallback(
		'updateProperty',
		{},
		(payload: { message: { key: string; value: any } }) => {
			const config = store.getters[GET_MXR_CONFIG];
			const { key, value } = payload.message;

			config[key] = value;

			store.dispatch(SET_MXR_CONFIG, config as IMxrConfig);
		}
	);
	meu.addMessageCallback(
		'updateArrayProperty',
		{},
		(payload: { message: { key: string; value: any; index: number } }) => {
			const config = store.getters[GET_MXR_CONFIG];
			const { key, value, index } = payload.message;
			config[key][index] = value;
			store.dispatch(SET_MXR_CONFIG, config as IMxrConfig);

			// hack: the cards component is not reactive to direct store changes
			// and has to be redrawn in order to display updates to card values.
			if (key !== 'cards') {
				return;
			}

			store.commit('PREV_CARD');
			store.commit('NEXT_CARD');
		}
	);
	meu.addMessageCallback('addCard', {}, (payload) => {
		const config = store.getters[GET_MXR_CONFIG];
		config.cards = config.cards ? config.cards : [];
		const index = config.cards.length;
		config.cards.push(payload.message.card);
		store.dispatch(SET_MXR_CONFIG, config as IMxrConfig);
		store.dispatch(SET_ACTIVE_CARD, index);
	});
};
